// extracted by mini-css-extract-plugin
module.exports = {"containerRange":"_12KLKEMECGRse9fYiVO-nj","date":"KKhoadkO8zffbcXfbm9M_"};